export enum LogoContainerType {
    SMALL = 'small',
    BANNER = 'banner',
    TALL = 'tall'
}

export default LogoContainerType;
